import { render, staticRenderFns } from "./duolifangzhuan.vue?vue&type=template&id=2d4128fe&scoped=true&"
import script from "./duolifangzhuan.vue?vue&type=script&lang=js&"
export * from "./duolifangzhuan.vue?vue&type=script&lang=js&"
import style0 from "./duolifangzhuan.vue?vue&type=style&index=0&id=2d4128fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4128fe",
  null
  
)

export default component.exports